import {ChangeDetectionStrategy, Component, ElementRef, output, viewChild, input} from '@angular/core';

@Component({
  selector: 'ui-search',
  standalone: true,
  templateUrl: './search.html',
  styleUrls: ['./search.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent {
  readonly search = viewChild<ElementRef>('search');
  readonly value = input('');
  readonly showButton = input(true);
  readonly showIcon = input(false);
  readonly showClear = input(false);
  readonly placeholder = input('');
  readonly valueChange = output<number>();
  readonly onSearch = output<string>();
  readonly focus = output<void>();
  readonly blur = output<void>();

  performSearch(value: string) {
    this.onSearch.emit(value);
  }

  onFocus() {
    this.focus.emit();
  }

  onBlur() {
    this.blur.emit();
  }

  setFocus() {
    this.search()?.nativeElement?.focus();
  }
}
